import { VideoStatus } from 'lib/const';
import keyBy from 'lodash/keyBy';

import { GlobalAction, VideoRequest, VideoRequestState } from '.';

const GET_PENDING_VIDEO_REQUESTS_COUNT_START = 'GET_VIDEO_REQUESTS_COUNT_START';
const GET_PENDING_VIDEO_REQUESTS_COUNT_ERROR = 'GET_VIDEO_REQUESTS_COUNT_ERROR';
const GET_PENDING_VIDEO_REQUESTS_COUNT_SUCCESS =
  'GET_VIDEO_REQUESTS_COUNT_SUCCESS';
const GET_PENDING_VIDEO_REQUESTS_START = 'GET_PENDING_VIDEO_REQUESTS_START';
const GET_PENDING_VIDEO_REQUESTS_ERROR = 'GET_PENDING_VIDEO_REQUESTS_ERROR';
const GET_PENDING_VIDEO_REQUESTS_SUCCESS = 'GET_PENDING_VIDEO_REQUESTS_SUCCESS';
const GET_PAST_VIDEO_REQUESTS_START = 'GET_PAST_VIDEO_REQUESTS_START';
const GET_PAST_VIDEO_REQUESTS_ERROR = 'GET_PAST_VIDEO_REQUESTS_ERROR';
const GET_PAST_VIDEO_REQUESTS_SUCCESS = 'GET_PAST_VIDEO_REQUESTS_SUCCESS';
const GET_VIDEO_REQUEST_START = 'GET_VIDEO_REQUEST_START';
const GET_VIDEO_REQUEST_ERROR = 'GET_VIDEO_REQUEST_ERROR';
const GET_VIDEO_REQUEST_SUCCESS = 'GET_VIDEO_REQUEST_SUCCESS';
const EDIT_VIDEO_REQUEST_START = 'EDIT_VIDEO_REQUEST_START';
const EDIT_VIDEO_REQUEST_ERROR = 'EDIT_VIDEO_REQUEST_ERROR';
const EDIT_VIDEO_REQUEST_SUCCESS = 'EDIT_VIDEO_REQUEST_SUCCESS';
const REASSIGN_VIDEO_REQUEST_START = 'REASSIGN_VIDEO_REQUEST_START';
const REASSIGN_VIDEO_REQUEST_ERROR = 'REASSIGN_VIDEO_REQUEST_ERROR';
const REASSIGN_VIDEO_REQUEST_SUCCESS = 'REASSIGN_VIDEO_REQUEST_SUCCESS';

export const videoRequestReducer = (
  state: VideoRequestState,
  action: GlobalAction
): VideoRequestState => {
  const { payload, type } = action;
  switch (type) {
    case GET_VIDEO_REQUEST_START:
    case GET_PAST_VIDEO_REQUESTS_START:
    case GET_PENDING_VIDEO_REQUESTS_START:
    case REASSIGN_VIDEO_REQUEST_START:
    case EDIT_VIDEO_REQUEST_START: {
      return {
        ...state,
        loading: true,
      };
    }
    case GET_PENDING_VIDEO_REQUESTS_ERROR:
    case GET_PAST_VIDEO_REQUESTS_ERROR:
    case GET_VIDEO_REQUEST_ERROR:
    case REASSIGN_VIDEO_REQUEST_ERROR:
    case EDIT_VIDEO_REQUEST_ERROR: {
      return {
        ...state,
        loading: false,
      };
    }
    case GET_VIDEO_REQUEST_SUCCESS:
    case REASSIGN_VIDEO_REQUEST_SUCCESS:
    case EDIT_VIDEO_REQUEST_SUCCESS: {
      let pastVideoRequests = state.pastVideoRequests;
      let pendingVideoRequests = state.pendingVideoRequests;
      if (
        payload.videoRequest.status === VideoStatus.Denied ||
        payload.videoRequest.status === VideoStatus.Approved
      ) {
        pastVideoRequests = {
          ...pastVideoRequests,
          [payload.videoRequest.videoRequestId]: payload.videoRequest,
        };
      } else if (payload.videoRequest.status === VideoStatus.Pending) {
        pendingVideoRequests = {
          ...pendingVideoRequests,
          [payload.videoRequest.videoRequestId]: payload.videoRequest,
        };
      }
      return {
        ...state,
        loading: false,
        pendingVideoRequests: pendingVideoRequests,
        pastVideoRequests: pastVideoRequests,
      };
    }
    case GET_PENDING_VIDEO_REQUESTS_SUCCESS: {
      return {
        ...state,
        pendingVideoRequests: keyBy(payload.videoRequests, 'videoRequestId'),
        countPending: payload.count,
        orderPending: payload.videoRequests.map(
          (videoRequest: VideoRequest) => videoRequest.videoRequestId
        ),
        loading: false,
      };
    }
    case GET_PAST_VIDEO_REQUESTS_SUCCESS: {
      return {
        ...state,
        pastVideoRequests: keyBy(payload.videoRequests, 'videoRequestId'),
        countPast: payload.count,
        orderPast: payload.videoRequests.map(
          (videoRequest: VideoRequest) => videoRequest.videoRequestId
        ),
        loading: false,
      };
    }
    case GET_PENDING_VIDEO_REQUESTS_COUNT_SUCCESS: {
      return {
        ...state,
        countPending: payload.count,
      };
    }
    default:
      return state;
  }
};

export const VIDEO_REQUESTS_ACTIONS = {
  GET_PENDING_VIDEO_REQUESTS_COUNT_START,
  GET_PENDING_VIDEO_REQUESTS_COUNT_ERROR,
  GET_PENDING_VIDEO_REQUESTS_COUNT_SUCCESS,
  GET_PENDING_VIDEO_REQUESTS_START,
  GET_PENDING_VIDEO_REQUESTS_ERROR,
  GET_PENDING_VIDEO_REQUESTS_SUCCESS,
  GET_PAST_VIDEO_REQUESTS_START,
  GET_PAST_VIDEO_REQUESTS_ERROR,
  GET_PAST_VIDEO_REQUESTS_SUCCESS,
  GET_VIDEO_REQUEST_START,
  GET_VIDEO_REQUEST_ERROR,
  GET_VIDEO_REQUEST_SUCCESS,
  EDIT_VIDEO_REQUEST_START,
  EDIT_VIDEO_REQUEST_ERROR,
  EDIT_VIDEO_REQUEST_SUCCESS,
  REASSIGN_VIDEO_REQUEST_START,
  REASSIGN_VIDEO_REQUEST_ERROR,
  REASSIGN_VIDEO_REQUEST_SUCCESS,
};
